export const mapEntriesToOptions = ([value, label]: [string, string]): {
  value: string
  label: string
} => ({ value, label })
